import URlS from "~/api/urls";
import { FormWithToken } from "~/types/form.interface";

export type RecaptchaSubmitResult = {
  success: boolean;
  requiresV2?: boolean;
};

export const submitRecaptcha = async (
  recaptchaFields: FormWithToken
): Promise<RecaptchaSubmitResult> => {
  return await $fetch(URlS.form.submitRecaptcha, {
    method: "POST",
    body: recaptchaFields,
  });
};
